module.exports = __webpack_public_path__ + "static/img/AI研选.f69f200.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AI研选.jpg
// module id = x1U6
// module chunks = 3